import { availableFlags, SmartChipFlag } from '@resistapp/common/types';

export const chipViewHighlightSelectedValue = 'HighlightSelected' as const;

export type StoredChipViewHighlightValue = SmartChipFlag | 'None' | typeof chipViewHighlightSelectedValue;
export type ChipViewHighlightMode = SmartChipFlag | typeof chipViewHighlightSelectedValue;

const smartChipFlagSet = new Set<SmartChipFlag>(availableFlags);

export function getChipViewHighlightMode(
  storedValue: StoredChipViewHighlightValue | null | undefined,
): ChipViewHighlightMode {
  if (storedValue === chipViewHighlightSelectedValue) {
    return chipViewHighlightSelectedValue;
  }

  return smartChipFlagSet.has(storedValue as SmartChipFlag)
    ? (storedValue as SmartChipFlag)
    : chipViewHighlightSelectedValue;
}

export function getResearchAdminHighlightFlag(
  storedValue: StoredChipViewHighlightValue | null | undefined,
): SmartChipFlag | null {
  return smartChipFlagSet.has(storedValue as SmartChipFlag) ? (storedValue as SmartChipFlag) : null;
}

export function shouldDrawChipSelectionHighlight(
  highlightMode: ChipViewHighlightMode,
  selectedSamples: string[] | null,
  selectedAssays: string[] | null,
): boolean {
  return highlightMode === chipViewHighlightSelectedValue && (selectedSamples != null || selectedAssays != null);
}
